import * as React from 'react';
import { createContext, Reducer, useContext, useReducer } from 'react';
import { IDocumentsApplicationState } from './interfaces';
import { DocumentsReducer } from './reducers';
import { DocumentDispatch, IDocumentAction } from './actions';
import { useAsyncEffect } from 'ui-toolkit';
import { getDocumentsByOrderAsync } from './service';
import { IDocumentCategory } from '../../types/order/documents/IDocumentCategoryType';

export const DocumentsContext = createContext<IDocumentsApplicationState | undefined>(undefined);

export const DocumentsDispatchContext = createContext<DocumentDispatch | undefined>(undefined);

interface IDocumentsProviderProps {
  documentID?: string;
  orderID: string;
  documentCategories: IDocumentCategory[];
  creatableDocumentCategories?: IDocumentCategory[];
  children: React.ReactNode;
}

// TODO: remove use of IStandardDocumentCategoryOption
export const DocumentsProvider: React.FC<IDocumentsProviderProps> = ({
  children,
  documentID,
  orderID,
  documentCategories,
  creatableDocumentCategories,
}) => {
  const [context, dispatch] = useReducer<Reducer<IDocumentsApplicationState, IDocumentAction>>(DocumentsReducer, {
    upload: {
      orderID,
      documents: [],
      isLoading: false,
      isComplete: false,
      hasError: false,
      creatableDocumentCategories: creatableDocumentCategories,
    },
    edit: {
      showModal: !!documentID,
      isLoading: true,
    },
    shared: {
      documentCategories,
      standardDocuments: [],
    },
  });

  useAsyncEffect(async () => {
    const standardDocuments = await getDocumentsByOrderAsync(orderID);
    dispatch({ type: 'SetSharedStandardDocuments', payload: standardDocuments });
  }, [orderID]);

  return (
    <DocumentsContext.Provider value={context}>
      <DocumentsDispatchContext.Provider value={dispatch}>{children}</DocumentsDispatchContext.Provider>
    </DocumentsContext.Provider>
  );
};

export const useDocumentsContext = (): [IDocumentsApplicationState, DocumentDispatch] => {
  const context = useContext(DocumentsContext);
  const dispatch = useContext(DocumentsDispatchContext);
  if (context === undefined || dispatch === undefined) {
    throw new Error('useDocumentsContext must be used within a DocumentsProvider');
  }
  return [context, dispatch];
};
